/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TicketType = {
    _11184809: '11184809',
    INSTANT: 'INSTANT',
    DRAW: 'DRAW',
    RAPID: 'RAPID',
    FAST_PLAY: 'FAST_PLAY',
    UNKNOWN: 'UNKNOWN',
    unknown_default_open_api: '11184809'
} as const;
export type TicketType = typeof TicketType[keyof typeof TicketType];


export function instanceOfTicketType(value: any): boolean {
    for (const key in TicketType) {
        if (Object.prototype.hasOwnProperty.call(TicketType, key)) {
            if (TicketType[key as keyof typeof TicketType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TicketTypeFromJSON(json: any): TicketType {
    return TicketTypeFromJSONTyped(json, false);
}

export function TicketTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketType {
    return json as TicketType;
}

export function TicketTypeToJSON(value?: TicketType | null): any {
    return value as any;
}

